import type { I18nFn } from '#/i18n/types/I18nFn';

import type { SearchEventRefinementType } from './searchEventRefinementTypes';
import {
  SEARCH_EVENT_REFINEMENT_LABELS,
  SEARCH_EVENT_REFINEMENT_NAMES,
} from './searchEventRefinementTypes';
import {
  SEARCH_GROUPS_REFINEMENT_LABELS,
  SEARCH_GROUPS_REFINEMENT_NAMES,
} from './searchGroupsRefinementTypes';
import type { SearchInternshipRefinementType } from './searchInternshipRefinementTypes';
import {
  SEARCH_INTERNSHIP_REFINEMENT_LABELS,
  SEARCH_INTERNSHIP_REFINEMENT_NAMES,
} from './searchInternshipRefinementTypes';
import type { SearchJobsRefinementType } from './searchJobsRefinementTypes';
import {
  SEARCH_JOB_REFINEMENT_LABELS,
  SEARCH_JOBS_REFINEMENT_NAMES,
} from './searchJobsRefinementTypes';
import {
  SEARCH_ORGS_REFINEMENT_LABELS,
  SEARCH_ORGS_REFINEMENT_NAMES,
} from './searchOrgsRefinementTypes';
import type { SearchVolopRefinementType } from './searchVolopRefinementTypes';
import {
  SEARCH_VOLOP_REFINEMENT_LABELS,
  SEARCH_VOLOP_REFINEMENT_NAMES,
} from './searchVolopRefinementTypes';

export type SearchRefinementType =
  | SearchJobsRefinementType
  | SearchInternshipRefinementType
  | SearchVolopRefinementType
  | SearchEventRefinementType;

export const SEARCH_REFINEMENT_NAMES = {
  JOB: SEARCH_JOBS_REFINEMENT_NAMES,
  INTERNSHIP: SEARCH_INTERNSHIP_REFINEMENT_NAMES,
  VOLOP: SEARCH_VOLOP_REFINEMENT_NAMES,
  ORG: SEARCH_ORGS_REFINEMENT_NAMES,
  GROUP: SEARCH_GROUPS_REFINEMENT_NAMES,
  EVENT: SEARCH_EVENT_REFINEMENT_NAMES,
} as const;

export function SEARCH_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    JOB: SEARCH_JOB_REFINEMENT_LABELS(i18n),
    INTERNSHIP: SEARCH_INTERNSHIP_REFINEMENT_LABELS(i18n),
    VOLOP: SEARCH_VOLOP_REFINEMENT_LABELS(i18n),
    ORG: SEARCH_ORGS_REFINEMENT_LABELS(i18n),
    GROUP: SEARCH_GROUPS_REFINEMENT_LABELS(i18n),
    EVENT: SEARCH_EVENT_REFINEMENT_LABELS(i18n),
  } as const;
}
